// extracted by mini-css-extract-plugin
module.exports = {"crate-card__artist":"crate-card_crate-card__artist__h3qx3"};